// extracted by mini-css-extract-plugin
export var root = "modal-x-module--root--pxUG4";